import { createFileRoute } from "@tanstack/react-router";

import { MiniSprintForm } from "~/components/forms/mini-sprint-form";
import { OfferForm, getOfferData } from "~/components/forms/offer-form";
import { useCoachPrivateProfileRequired } from "~/contexts/coach";
import { getCoachOffer } from "~/lib/functions/coach-offers";
import { OfferType } from "~/lib/schemas/db-enums";
import { canEditOffer } from "~/lib/shared/offer-lifecycle";

export const Route = createFileRoute(
  "/_user/my-coaching/profile/offers/$offerId",
)({
  staticData: { title: "Edit offer" },
  loader: async ({ params, context }) => {
    const offer = await getOfferData({ data: { offerId: params.offerId } });
    // The primary offer is the one the list's main slot opens: the main offer,
    // or the draft that becomes it once published. Only standard offers can
    // be it.
    const primaryOffer =
      offer.type !== OfferType.Standard
        ? null
        : await context.queryClient.ensureQueryData({
            queryKey: ["coach", "main-offer"],
            queryFn: () => getCoachOffer(),
          });
    return { offer, primaryOfferId: primaryOffer?.id ?? null };
  },
  component: OfferEditPage,
});

function OfferEditPage() {
  const coach = useCoachPrivateProfileRequired();
  const { offer, primaryOfferId } = Route.useLoaderData();

  if (
    !canEditOffer({
      offer,
      primaryOfferId,
      membershipPlan: coach.membershipPlan,
    })
  ) {
    throw new Error("Only ProPlus members can edit additional offers");
  }

  if (offer.type === OfferType.MiniSprint) {
    return (
      <MiniSprintForm
        initialData={offer}
        title="Edit Mini Sprint"
        titleAs="h2"
      />
    );
  }

  return (
    <OfferForm
      initialData={offer}
      titleAs="h2"
      title={offer.id ? "Edit offer" : "Create new offer"}
    />
  );
}
